module.exports = __webpack_public_path__ + "prod/1.42.2/img/cover-picture.6f1942c3.png";